/**
 * Browser entry point: styles, router, providers, app.
 *
 * No configuration is hardcoded here — the API base URL comes from
 * `VITE_API_BASE_URL` (see `lib/api-client.ts`) and defaults to a same-origin
 * relative path, so one built bundle runs in every environment.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { AppProviders } from './app/providers';
import { AppRoutes } from './app/router';
import './styles/tokens.css';
import './styles/base.css';
import './styles/shell.css';
import './styles/data-table.css';
import './styles/segmented.css';
import './styles/events.css';
import './styles/play-entry.css';
import './styles/play-entry-console.css';
import './styles/layout-platform.css';
import './styles/archive.css';
import './styles/highlight.css';
import './styles/highlight-board.css';
import './styles/summary.css';
import './styles/playbook.css';
import './styles/stat-cards.css';
import './styles/entry-cards.css';
import './styles/stat-fields.css';
import './styles/billing.css';
import './styles/team-settings.css';
import './styles/settings.css';
import './styles/home.css';
import './styles/live-video.css';
import './styles/marketing.css';
import './styles/auth.css';
import './styles/fanatic.css';
import './styles/integrations.css';
import './styles/federation.css';
import './styles/help.css';
import './styles/admin.css';
// Last on purpose: desk density overrides page sizing on in-scope pages only.
import './styles/desk.css';

class BootstrapError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'BootstrapError';
  }
}

const container = document.getElementById('root');
if (container === null) {
  throw new BootstrapError('#root is missing from index.html — the app cannot mount.');
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <AppProviders>
        <AppRoutes />
      </AppProviders>
    </BrowserRouter>
  </StrictMode>
);
